/**
 * Lazy-loaded Component Definitions
 *
 * All lazy-loaded components for code splitting
 */

import { LoadingFallback, withLazyLoading } from "../utils/LazyLoadingUtils";

export const ArticleRouter = withLazyLoading(
  () => import("../components/articles/ArticleRouter"),
  <LoadingFallback message="Loading article..." />,
);

export const ProductViewer = withLazyLoading(
  () => import("../components/products/ProductViewer"),
  <LoadingFallback message="Loading products..." />,
);

export const AIServiceViewer = withLazyLoading(
  () => import("../components/aiservices/AIServiceViewer"),
  <LoadingFallback message="Loading AI services..." />,
);

export const JobViewer = withLazyLoading(
  () => import("../components/careers/JobViewer"),
  <LoadingFallback message="Loading careers..." />,
);

export const AboutUs = withLazyLoading(
  () => import("../components/pages/AboutUsPage"),
  <LoadingFallback message="Loading about page..." />,
);

export const PrivacyPolicyPage = withLazyLoading(
  () => import("../components/pages/legal/PrivacyPolicyPage"),
  <LoadingFallback message="Loading privacy policy..." />,
);

export const TermsOfServicePage = withLazyLoading(
  () => import("../components/pages/legal/TermsOfServicePage"),
  <LoadingFallback message="Loading terms of service..." />,
);

export const CookiePolicyPage = withLazyLoading(
  () => import("../components/pages/legal/CookiePolicyPage"),
  <LoadingFallback message="Loading cookie policy..." />,
);

export const GdprPage = withLazyLoading(
  () => import("../components/pages/legal/GdprPage"),
  <LoadingFallback message="Loading GDPR information..." />,
);

export const MagazinePage = withLazyLoading(
  () => import("../components/pages/MagazinePage"),
  <LoadingFallback message="Loading magazine..." />,
);

export const BusinessOverview = withLazyLoading(
  () => import("../components/business/BusinessOverviewPage"),
  <LoadingFallback message="Loading business overview..." />,
);

export const ContactSales = withLazyLoading(
  () => import("../components/business/ContactSalesPage"),
  <LoadingFallback message="Loading contact page..." />,
);

export const ApiDocumentation = withLazyLoading(
  () => import("../components/business/ApiDocumentationPage"),
  <LoadingFallback message="Loading API docs..." />,
);

export const PricingPage = withLazyLoading(
  () => import("../components/business/PricingPage"),
  <LoadingFallback message="Loading pricing..." />,
);

export const ApiKeysPage = withLazyLoading(
  () => import("../components/account/ApiKeysPage"),
  <LoadingFallback message="Loading API keys..." />,
);

export const UserPage = withLazyLoading(
  () => import("../components/account/UserPage"),
  <LoadingFallback message="Loading user profile..." />,
);

export const TopUpPage = withLazyLoading(
  () => import("../components/account/TopUpPage"),
  <LoadingFallback message="Loading top up page..." />,
);

export const ViewUsagePage = withLazyLoading(
  () => import("../components/account/ViewUsagePage"),
  <LoadingFallback message="Loading usage analytics..." />,
);

export const ReceiptsPage = withLazyLoading(
  () => import("../components/account/ReceiptsPage"),
  <LoadingFallback message="Loading receipts..." />,
);

export const ReceiptDetailPage = withLazyLoading(
  () => import("../components/account/ReceiptDetailPage"),
  <LoadingFallback message="Loading receipt..." />,
);

export const PaymentSuccessPage = withLazyLoading(
  () => import("../components/account/PaymentSuccessPage"),
  <LoadingFallback message="Finalizing payment..." />,
);

export const PaymentCancelPage = withLazyLoading(
  () => import("../components/account/PaymentCancelPage"),
  <LoadingFallback message="Returning from checkout..." />,
);

export const ForgotPasswordPage = withLazyLoading(
  () => import("../components/auth/ForgotPasswordPage"),
  <LoadingFallback message="Loading forgot password..." />,
);

export const ResetPasswordPage = withLazyLoading(
  () => import("../components/auth/ResetPasswordPage"),
  <LoadingFallback message="Loading reset password..." />,
);
